import axios from "axios";
import React, { useState, useEffect } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import "../css/styles.css";
import { fetchToken } from "./Auth";

const addDays = (dateString, days) => {
  if (!dateString) return "";
  try {
    const date = new Date(dateString + "T00:00:00");
    date.setDate(date.getDate() + days);
    return date.toISOString().split("T")[0];
  } catch (e) {
    return "";
  }
};

const formatDateForInput = (dateString) => {
  if (!dateString) return "";
  try {
    return new Date(dateString).toISOString().split("T")[0];
  } catch (e) {
    return "";
  }
};

const formatBRL = (value) => {
  if (!value) return "";
  let digits = String(value).replace(/\D/g, "");
  if (digits.length > 10) {
    digits = digits.slice(0, 10);
  }
  digits = digits.padStart(3, "0");
  const cents = digits.slice(-2);
  const integer = digits.slice(0, -2);
  const integerFormatted = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  return `R$ ${integerFormatted},${cents}`;
};

function EditProjetoCompleto() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [listaSecretarias, setListaSecretarias] = useState([]);

  const [id_secretaria, setSecretaria] = useState("");
  const [nomeprojeto, setNomeprojeto] = useState("");
  const [descricao, setDescricao] = useState("");
  const [ano_projeto, setAno_projeto] = useState("");
  const [processo_egov, setProcesso_egov] = useState("");
  const [numero_demanda, setNumero_demanda] = useState("");
  const [numero_convenio, setNumero_convenio] = useState("");
  const [valor_repasse, setValor_repasse] = useState("");
  const [valor_contrapartida, setValor_contrapartida] = useState("");
  const [parlamentar, setParlamentar] = useState("");
  const [contador, setContador] = useState("");
  const [gestor, setGestor] = useState("");
  const [fiscal, setFiscal] = useState("");
  const [data_assinatura_termo, setData_assinatura_termo] = useState("");
  const [vigencia_termo, setVigencia_termo] = useState("");

  // --- ATUALIZAÇÃO NOS ESTADOS DE FONTE ---
  const [fonte_contrapartida, setFonte_contrapartida] = useState("");
  const [fonte_repasse, setFonte_repasse] = useState("");

  const [manual_etapa1, setManualEtapa1] = useState(false);
  const [manual_etapa2, setManualEtapa2] = useState(false);
  const [manual_etapa3, setManualEtapa3] = useState(false);
  const [manual_etapa4, setManualEtapa4] = useState(false);
  const [manual_etapa5, setManualEtapa5] = useState(false);
  const [manual_etapa6, setManualEtapa6] = useState(false);

  const [data_inicio_etapa1, setData_inicio_etapa1] = useState("");
  const [data_termino_etapa1, setData_termino_etapa1] = useState("");
  const [prazo_etapa1, setPrazo_etapa1] = useState("90");
  const [situacao_etapa1, setSituacao_etapa1] = useState("");
  const [status_etapa1, setStatus_etapa1] = useState("");

  const [data_inicio_etapa2, setData_inicio_etapa2] = useState("");
  const [data_termino_etapa2, setData_termino_etapa2] = useState("");
  const [prazo_etapa2, setPrazo_etapa2] = useState("120");
  const [situacao_etapa2, setSituacao_etapa2] = useState("");
  const [status_etapa2, setStatus_etapa2] = useState("");

  const [data_inicio_etapa3, setData_inicio_etapa3] = useState("");
  const [data_termino_etapa3, setData_termino_etapa3] = useState("");
  const [prazo_etapa3, setPrazo_etapa3] = useState("120");
  const [situacao_etapa3, setSituacao_etapa3] = useState("");
  const [status_etapa3, setStatus_etapa3] = useState("");

  const [assinatura_contrato, setAssinatura_contrato] = useState("");
  const [vigencia_contrato, setVigencia_contrato] = useState("");
  const [data_inicio_etapa4, setData_inicio_etapa4] = useState("");
  const [data_termino_etapa4, setData_termino_etapa4] = useState("");
  const [prazo_etapa4, setPrazo_etapa4] = useState("30");
  const [situacao_etapa4, setSituacao_etapa4] = useState("");
  const [status_etapa4, setStatus_etapa4] = useState("");

  const [data_ois, setData_ois] = useState("");
  const [data_inicio_etapa5, setData_inicio_etapa5] = useState("");
  const [data_termino_etapa5, setData_termino_etapa5] = useState("");
  const [prazo_etapa5, setPrazo_etapa5] = useState("180");
  const [situacao_etapa5, setSituacao_etapa5] = useState("");
  const [status_etapa5, setStatus_etapa5] = useState("");

  const [data_inicio_etapa6, setData_inicio_etapa6] = useState("");
  const [data_termino_etapa6, setData_termino_etapa6] = useState("");
  const [prazo_etapa6, setPrazo_etapa6] = useState("60");
  const [situacao_etapa6, setSituacao_etapa6] = useState("");
  const [status_etapa6, setStatus_etapa6] = useState("");

  const [registerStatus, setRegisterStatus] = useState("");

  // --- LISTA DE OPÇÕES DE FONTE (REUTILIZÁVEL) ---
  const opcoesFonte = (
    <>
      <option value="">Selecione a fonte</option>
      <option value="01-Tesouro">01-Tesouro</option>
      <option value="02-Transferência e Convênios Estaduais - Vinculados">
        02-Transferência e Convênios Estaduais - Vinculados
      </option>
      <option value="03-Recursos Próprios de Fundos Especiais e Despesas - Vinculados">
        03-Recursos Próprios de Fundos Especiais e Despesas - Vinculados
      </option>
      <option value="04-Recursos Próprios da Administração Indireta">
        04-Recursos Próprios da Administração Indireta
      </option>
      <option value="05-Transferência e Convênios Federais - Vinculados">
        05-Transferência e Convênios Federais - Vinculados
      </option>
      <option value="06-Outras Fontes de Recursos">
        06-Outras Fontes de Recursos
      </option>
      <option value="07-Operações de Crédito">07-Operações de Crédito</option>
      <option value="08-Emendas Parlamentares Individuais - Legislativo Municipal">
        08-Emendas Parlamentares Individuais - Legislativo Municipal
      </option>
      <option value="19-Recursos Extraorçamentários">
        19-Recursos Extraorçamentários
      </option>
    </>
  );

  // --- NOVO USEEFFECT PARA BUSCAR AS SECRETARIAS NO BANCO ---
  useEffect(() => {
    const token = fetchToken();
    axios
      .get("/api/secretaria", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        if (response.data.Status === "Success") {
          setListaSecretarias(response.data.Result);
        } else {
          console.error("Erro ao buscar secretarias:", response.data.Error);
        }
      })
      .catch((err) => {
        console.error("Erro na requisição de secretarias:", err);
      });
  }, []);

  // --- useEffect para buscar dados do projeto ---
  useEffect(() => {
    const token = fetchToken();
    if (!token) {
      alert("Sessão expirada. Faça login novamente.");
      navigate("/login");
      return;
    }

    axios
      .get(`/api/projetocompleto/${id}`)
      .then((res) => {
        if (res.data.Status === "Success" && res.data.Result.length > 0) {
          const data = res.data.Result[0];

          setSecretaria(data.id_secretaria || "");
          setNomeprojeto(data.nomeprojeto || "");
          setDescricao(data.descricao || "");
          setAno_projeto(data.ano_projeto || "");
          setProcesso_egov(data.processo_egov || "");
          setNumero_demanda(data.numero_demanda || "");
          setNumero_convenio(data.numero_convenio || "");
          setValor_repasse(formatBRL(data.valor_repasse));
          setValor_contrapartida(formatBRL(data.valor_contrapartida));
          setParlamentar(data.parlamentar || "");
          setContador(data.contador || "");
          setGestor(data.gestor || "");
          setFiscal(data.fiscal || "");

          // --- PREENCHENDO AS FONTES SEPARADAMENTE ---
          setFonte_repasse(data.fonte_repasse || "");
          setFonte_contrapartida(data.fonte_contrapartida || "");

          setData_assinatura_termo(
            formatDateForInput(data.data_assinatura_termo)
          );
          setVigencia_termo(formatDateForInput(data.vigencia_termo));
          setData_inicio_etapa1(formatDateForInput(data.data_inicio_etapa1));
          setData_termino_etapa1(formatDateForInput(data.data_termino_etapa1));
          setPrazo_etapa1(data.prazo_etapa1 || "90");
          setSituacao_etapa1(data.situacao_etapa1 || "");
          setStatus_etapa1(data.status_etapa1 || "");

          setData_inicio_etapa2(formatDateForInput(data.data_inicio_etapa2));
          setData_termino_etapa2(formatDateForInput(data.data_termino_etapa2));
          setPrazo_etapa2(data.prazo_etapa2 || "120");
          setSituacao_etapa2(data.situacao_etapa2 || "");
          setStatus_etapa2(data.status_etapa2 || "");

          setData_inicio_etapa3(formatDateForInput(data.data_inicio_etapa3));
          setData_termino_etapa3(formatDateForInput(data.data_termino_etapa3));
          setPrazo_etapa3(data.prazo_etapa3 || "120");
          setSituacao_etapa3(data.situacao_etapa3 || "");
          setStatus_etapa3(data.status_etapa3 || "");
          setAssinatura_contrato(formatDateForInput(data.assinatura_contrato));
          setVigencia_contrato(formatDateForInput(data.vigencia_contrato));

          setData_inicio_etapa4(formatDateForInput(data.data_inicio_etapa4));
          setData_termino_etapa4(formatDateForInput(data.data_termino_etapa4));
          setPrazo_etapa4(data.prazo_etapa4 || "30");
          setSituacao_etapa4(data.situacao_etapa4 || "");
          setStatus_etapa4(data.status_etapa4 || "");
          setData_ois(formatDateForInput(data.data_ois));

          setData_inicio_etapa5(formatDateForInput(data.data_inicio_etapa5));
          setData_termino_etapa5(formatDateForInput(data.data_termino_etapa5));
          setPrazo_etapa5(data.prazo_etapa5 || "180");
          setSituacao_etapa5(data.situacao_etapa5 || "");
          setStatus_etapa5(data.status_etapa5 || "");

          setData_inicio_etapa6(formatDateForInput(data.data_inicio_etapa6));
          setData_termino_etapa6(formatDateForInput(data.data_termino_etapa6));
          setPrazo_etapa6(data.prazo_etapa6 || "60");
          setSituacao_etapa6(data.situacao_etapa6 || "");
          setStatus_etapa6(data.status_etapa6 || "");
        } else {
          alert("Projeto não encontrado.");
          navigate("/projetocompleto");
        }
      })
      .catch((err) => {
        console.error("Erro ao buscar projeto:", err);
        alert("Erro ao carregar dados do projeto.");
        navigate("/projetocompleto");
      });
  }, [id, navigate]);

  useEffect(() => {
    if (!manual_etapa1) {
      if (data_inicio_etapa1) {
        setData_termino_etapa1(addDays(data_inicio_etapa1, 90));
        setPrazo_etapa1("90");
      }
    }
  }, [data_inicio_etapa1, manual_etapa1]);

  useEffect(() => {
    if (!manual_etapa2) {
      if (data_inicio_etapa2) {
        setData_termino_etapa2(addDays(data_inicio_etapa2, 120));
        setPrazo_etapa2("120");
      }
    }
  }, [data_inicio_etapa2, manual_etapa2]);

  useEffect(() => {
    if (!manual_etapa3) {
      if (data_inicio_etapa3) {
        setData_termino_etapa3(addDays(data_inicio_etapa3, 120));
        setPrazo_etapa3("120");
      }
    }
  }, [data_inicio_etapa3, manual_etapa3]);

  useEffect(() => {
    if (!manual_etapa4) {
      if (data_inicio_etapa4) {
        setData_termino_etapa4(addDays(data_inicio_etapa4, 30));
        setPrazo_etapa4("30");
      }
    }
  }, [data_inicio_etapa4, manual_etapa4]);

  useEffect(() => {
    if (!manual_etapa5) {
      if (data_inicio_etapa5) {
        setData_termino_etapa5(addDays(data_inicio_etapa5, 180));
        setPrazo_etapa5("180");
      }
    }
  }, [data_inicio_etapa5, manual_etapa5]);

  useEffect(() => {
    if (!manual_etapa6) {
      if (data_inicio_etapa6) {
        setData_termino_etapa6(addDays(data_inicio_etapa6, 60));
        setPrazo_etapa6("60");
      }
    }
  }, [data_inicio_etapa6, manual_etapa6]);

  const handleCurrencyChange = (e, setter) => {
    const formattedValue = formatBRL(e.target.value);
    setter(formattedValue);
  };

  const handleUpdate = (e) => {
    e.preventDefault();
    const token = fetchToken();

    if (!token) {
      setRegisterStatus("Erro: Token não encontrado. Faça login novamente.");
      return;
    }

    const cleanValue = (value) => {
      if (typeof value !== "string") return value;
      return value
        .replace("R$", "")
        .replace(/\./g, "")
        .replace(",", ".")
        .trim();
    };

    const valorRepasseLimpo = cleanValue(valor_repasse);
    const valorContrapartidaLimpo = cleanValue(valor_contrapartida);

    axios
      .put(
        `/api/projetocompleto/${id}`,
        {
          id_secretaria,
          nomeprojeto,
          descricao,
          ano_projeto,
          processo_egov,
          numero_demanda,
          numero_convenio,
          valor_repasse: valorRepasseLimpo,
          valor_contrapartida: valorContrapartidaLimpo,
          // --- ENVIANDO AS FONTES SEPARADAS ---
          fonte_repasse,
          fonte_contrapartida,
          parlamentar,
          data_inicio_etapa1,
          data_termino_etapa1,
          prazo_etapa1,
          situacao_etapa1,
          status_etapa1,
          contador,
          gestor,
          fiscal,
          data_assinatura_termo,
          vigencia_termo,
          data_inicio_etapa2,
          data_termino_etapa2,
          prazo_etapa2,
          situacao_etapa2,
          status_etapa2,
          data_inicio_etapa3,
          data_termino_etapa3,
          prazo_etapa3,
          situacao_etapa3,
          status_etapa3,
          assinatura_contrato,
          vigencia_contrato,
          data_inicio_etapa4,
          data_termino_etapa4,
          prazo_etapa4,
          situacao_etapa4,
          status_etapa4,
          data_ois,
          data_inicio_etapa5,
          data_termino_etapa5,
          situacao_etapa5,
          prazo_etapa5,
          status_etapa5,
          data_inicio_etapa6,
          data_termino_etapa6,
          prazo_etapa6,
          situacao_etapa6,
          status_etapa6,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        if (response.data.Status === "Success") {
          navigate("/projetocompleto");
          alert("Projeto atualizado com sucesso!");
        } else {
          setRegisterStatus(response.data.message || "Erro ao atualizar.");
        }
      })
      .catch((err) => {
        console.log(err);
        if (err.response?.data?.details?.includes("Out of range")) {
          setRegisterStatus(
            "Erro: Valor muito alto! O máximo permitido é R$ 99.999.999,99."
          );
        } else {
          setRegisterStatus(
            err.response?.data?.error ||
              err.response?.data?.message ||
              "Erro ao atualizar projeto."
          );
        }
      });
  };

  return (
    <form className="container" onSubmit={handleUpdate}>
      <h2>EDITAR PROJETO (ID: {id})</h2>
      <div className="fs-1 px-5 py-3">
        <Link to="/numero" className="btn btn-info px-5 g-5 me-2">
          Dashboard
        </Link>
        <Link
          to="/numero/projetocompleto"
          className="btn btn-warning px-5 g-5 me-2"
        >
          Retorna projeto
        </Link>
      </div>
      <div className="main-container">
        <div className="containerdashboard">
          <h1>{registerStatus}</h1>

          {/* --- Etapa 1 --- */}
          <h3>Etapa 1: Definição do objeto / Estruturação do projeto</h3>
          <div className="input-dividido">
            <div className="col">
              <label className="form-label">Secretaria</label>
              <select
                className="form-control"
                required
                value={id_secretaria}
                onChange={(e) => setSecretaria(e.target.value)}
              >
                <option value="">Selecione a secretaria</option>
                {listaSecretarias.map((sec) => (
                  <option key={sec.id} value={sec.id}>
                    {sec.nomesecretaria}
                  </option>
                ))}
              </select>
            </div>
            <div className="col">
              <label className="form-label">Nome do projeto</label>
              <input
                type="text"
                className="form-control"
                value={nomeprojeto}
                onChange={(e) => setNomeprojeto(e.target.value)}
              />
            </div>
          </div>
          <div className="input-dividido">
            <div className="col">
              <label className="form-label">Descrição</label>
              <input
                type="text"
                className="form-control"
                value={descricao}
                onChange={(e) => setDescricao(e.target.value)}
              />
            </div>
            <div className="col">
              <label className="form-label">Ano</label>
              <input
                type="number"
                className="form-control"
                value={ano_projeto}
                onChange={(e) => setAno_projeto(e.target.value)}
              />
            </div>
          </div>
          <div className="input-dividido">
            <div className="col">
              <label className="form-label">E-gov</label>
              <input
                type="text"
                className="form-control"
                value={processo_egov}
                onChange={(e) => setProcesso_egov(e.target.value)}
              />
            </div>
            <div className="col">
              <label className="form-label">Demanda</label>
              <input
                type="number"
                className="form-control"
                value={numero_demanda}
                onChange={(e) => setNumero_demanda(e.target.value)}
              />
            </div>
            <div className="col">
              <label className="form-label">Convênio</label>
              <input
                type="text"
                className="form-control"
                value={numero_convenio}
                onChange={(e) => setNumero_convenio(e.target.value)}
              />
            </div>
          </div>

          {/* --- BLOCO REPASSE --- */}
          <div className="input-dividido">
            <div className="col">
              <label className="form-label">Valor Repasse</label>
              <input
                type="text"
                className="form-control"
                value={valor_repasse}
                onChange={(e) => handleCurrencyChange(e, setValor_repasse)}
              />
            </div>
            <div className="col">
              <label className="form-label">Fonte do Repasse</label>
              <select
                className="form-control"
                value={fonte_repasse}
                onChange={(e) => setFonte_repasse(e.target.value)}
              >
                {opcoesFonte}
              </select>
            </div>
          </div>

          {/* --- BLOCO CONTRAPARTIDA --- */}
          <div className="input-dividido">
            <div className="col">
              <label className="form-label">Valor Contrapartida</label>
              <input
                type="text"
                className="form-control"
                value={valor_contrapartida}
                onChange={(e) =>
                  handleCurrencyChange(e, setValor_contrapartida)
                }
              />
            </div>
            <div className="col">
              <label className="form-label">Fonte da Contrapartida</label>
              <select
                className="form-control"
                value={fonte_contrapartida}
                onChange={(e) => setFonte_contrapartida(e.target.value)}
              >
                {opcoesFonte}
              </select>
            </div>
          </div>

          {/* --- BLOCO PARLAMENTAR --- */}
          <div className="input-dividido">
            <div className="col">
              <label className="form-label">Parlamentar</label>
              <input
                type="text"
                className="form-control"
                value={parlamentar}
                onChange={(e) => setParlamentar(e.target.value)}
              />
            </div>
          </div>

          {/* --- ALTERAÇÃO ETAPA 1 (Data Término com Checkbox) --- */}
          <div className="input-dividido">
            <div className="col">
              <label className="form-label">Data de Início Etapa 1</label>
              <input
                type="date"
                className="form-control"
                value={data_inicio_etapa1}
                onChange={(e) => setData_inicio_etapa1(e.target.value)}
              />
            </div>
            <div className="col">
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <label className="form-label">Data de Término Etapa 1</label>
                <div
                  className="form-check form-switch"
                  style={{ fontSize: "0.8rem" }}
                >
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={manual_etapa1}
                    onChange={(e) => setManualEtapa1(e.target.checked)}
                  />
                  <label className="form-check-label">Manual?</label>
                </div>
              </div>
              <input
                type="date"
                className="form-control"
                value={data_termino_etapa1}
                readOnly={!manual_etapa1}
                onChange={(e) => setData_termino_etapa1(e.target.value)}
              />
            </div>
          </div>
          <div className="input-dividido">
            <div className="col">
              <label className="form-label">Situação</label>
              <select
                className="form-control"
                value={situacao_etapa1}
                onChange={(e) => setSituacao_etapa1(e.target.value)}
              >
                <option value="">Escolher</option>
                <option value="Não iniciado">Não iniciado</option>
                <option value="Em andamento">Em andamento</option>
                <option value="Concluído">Concluído</option>
                <option value="Atrasado">Atrasado</option>
              </select>
            </div>
            <div className="col">
              <label className="form-label">Status</label>
              <input
                type="text"
                className="form-control"
                value={status_etapa1}
                onChange={(e) => setStatus_etapa1(e.target.value)}
              />
            </div>
          </div>
          <div className="input-dividido">
            <div className="col">
              <label className="form-label">Data Assinatura Termo</label>
              <input
                type="date"
                className="form-control"
                value={data_assinatura_termo}
                onChange={(e) => setData_assinatura_termo(e.target.value)}
              />
            </div>
            <div className="col">
              <label className="form-label">Vigência do Termo</label>
              <input
                type="date"
                className="form-control"
                value={vigencia_termo}
                onChange={(e) => setVigencia_termo(e.target.value)}
              />
            </div>
          </div>

          {/* --- Etapa 2 --- */}
          <hr />
          <h3>Etapa 2: TdR e Orçamento</h3>
          <div className="input-dividido">
            <div className="col">
              <label className="form-label">Contador</label>
              <input
                type="text"
                className="form-control"
                value={contador}
                onChange={(e) => setContador(e.target.value)}
              />
            </div>
            <div className="col">
              <label className="form-label">Gestor</label>
              <input
                type="text"
                className="form-control"
                value={gestor}
                onChange={(e) => setGestor(e.target.value)}
              />
            </div>
            <div className="col">
              <label className="form-label">Fiscal</label>
              <input
                type="text"
                className="form-control"
                value={fiscal}
                onChange={(e) => setFiscal(e.target.value)}
              />
            </div>
          </div>
          <div className="input-dividido">
            <div className="col">
              <label className="form-label">Data de Início Etapa 2</label>
              <input
                type="date"
                className="form-control"
                value={data_inicio_etapa2}
                onChange={(e) => setData_inicio_etapa2(e.target.value)}
              />
            </div>
            <div className="col">
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <label className="form-label">Data de Término Etapa 2</label>
                <div
                  className="form-check form-switch"
                  style={{ fontSize: "0.8rem" }}
                >
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={manual_etapa2}
                    onChange={(e) => setManualEtapa2(e.target.checked)}
                  />
                  <label className="form-check-label">Manual?</label>
                </div>
              </div>
              <input
                type="date"
                className="form-control"
                value={data_termino_etapa2}
                readOnly={!manual_etapa2}
                onChange={(e) => setData_termino_etapa2(e.target.value)}
              />
            </div>
          </div>
          <div className="input-dividido">
            <div className="col">
              <label className="form-label">Situação</label>
              <select
                className="form-control"
                value={situacao_etapa2}
                onChange={(e) => setSituacao_etapa2(e.target.value)}
              >
                <option value="">Escolher</option>
                <option value="Não iniciado">Não iniciado</option>
                <option value="Em andamento">Em andamento</option>
                <option value="Concluído">Concluído</option>
                <option value="Atrasado">Atrasado</option>
              </select>
            </div>
            <div className="col">
              <label className="form-label">Status</label>
              <input
                type="text"
                className="form-control"
                value={status_etapa2}
                onChange={(e) => setStatus_etapa2(e.target.value)}
              />
            </div>
          </div>

          {/* --- Etapa 3 --- */}
          <hr />
          <h3>Etapa 3: Licitação</h3>
          <div className="input-dividido">
            <div className="col">
              <label className="form-label">Data de Início Etapa 3</label>
              <input
                type="date"
                className="form-control"
                value={data_inicio_etapa3}
                onChange={(e) => setData_inicio_etapa3(e.target.value)}
              />
            </div>
            <div className="col">
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <label className="form-label">Data de Término Etapa 3</label>
                <div
                  className="form-check form-switch"
                  style={{ fontSize: "0.8rem" }}
                >
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={manual_etapa3}
                    onChange={(e) => setManualEtapa3(e.target.checked)}
                  />
                  <label className="form-check-label">Manual?</label>
                </div>
              </div>
              <input
                type="date"
                className="form-control"
                value={data_termino_etapa3}
                readOnly={!manual_etapa3}
                onChange={(e) => setData_termino_etapa3(e.target.value)}
              />
            </div>
          </div>
          <div className="input-dividido">
            <div className="col">
              <label className="form-label">Situação</label>
              <select
                className="form-control"
                value={situacao_etapa3}
                onChange={(e) => setSituacao_etapa3(e.target.value)}
              >
                <option value="">Escolher</option>
                <option value="Não iniciado">Não iniciado</option>
                <option value="Em andamento">Em andamento</option>
                <option value="Concluído">Concluído</option>
                <option value="Atrasado">Atrasado</option>
              </select>
            </div>
            <div className="col">
              <label className="form-label">Status</label>
              <input
                type="text"
                className="form-control"
                value={status_etapa3}
                onChange={(e) => setStatus_etapa3(e.target.value)}
              />
            </div>
          </div>

          {/* --- Etapa 4 --- */}
          <hr />
          <h3>Etapa 4: Contrato</h3>
          <div className="input-dividido">
            <div className="col">
              <label className="form-label">Assinatura</label>
              <input
                type="date"
                className="form-control"
                value={assinatura_contrato}
                onChange={(e) => setAssinatura_contrato(e.target.value)}
              />
            </div>
            <div className="col">
              <label className="form-label">Vigência</label>
              <input
                type="date"
                className="form-control"
                value={vigencia_contrato}
                onChange={(e) => setVigencia_contrato(e.target.value)}
              />
            </div>
          </div>
          <div className="input-dividido">
            <div className="col">
              <label className="form-label">Data de Início Etapa 4</label>
              <input
                type="date"
                className="form-control"
                value={data_inicio_etapa4}
                onChange={(e) => setData_inicio_etapa4(e.target.value)}
              />
            </div>
            <div className="col">
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <label className="form-label">Data de Término Etapa 4</label>
                <div
                  className="form-check form-switch"
                  style={{ fontSize: "0.8rem" }}
                >
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={manual_etapa4}
                    onChange={(e) => setManualEtapa4(e.target.checked)}
                  />
                  <label className="form-check-label">Manual?</label>
                </div>
              </div>
              <input
                type="date"
                className="form-control"
                value={data_termino_etapa4}
                readOnly={!manual_etapa4}
                onChange={(e) => setData_termino_etapa4(e.target.value)}
              />
            </div>
          </div>
          <div className="input-dividido">
            <div className="col">
              <label className="form-label">Situação</label>
              <select
                className="form-control"
                value={situacao_etapa4}
                onChange={(e) => setSituacao_etapa4(e.target.value)}
              >
                <option value="">Escolher</option>
                <option value="Não iniciado">Não iniciado</option>
                <option value="Em andamento">Em andamento</option>
                <option value="Concluído">Concluído</option>
                <option value="Atrasado">Atrasado</option>
              </select>
            </div>
            <div className="col">
              <label className="form-label">Status</label>
              <input
                type="text"
                className="form-control"
                value={status_etapa4}
                onChange={(e) => setStatus_etapa4(e.target.value)}
              />
            </div>
          </div>

          <hr />
          <h3>Etapa 5: Execução</h3>
          <div className="input-dividido">
            <div className="col">
              <label className="form-label">
                Data de Ordem de Início de Serviço
              </label>
              <input
                type="date"
                className="form-control"
                value={data_ois}
                onChange={(e) => setData_ois(e.target.value)}
              />
            </div>
            <div className="col">
              <label className="form-label">Data de Início Etapa 5</label>
              <input
                type="date"
                className="form-control"
                value={data_inicio_etapa5}
                onChange={(e) => setData_inicio_etapa5(e.target.value)}
              />
            </div>
            <div className="col">
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <label className="form-label">Data de Término Etapa 5</label>
                <div
                  className="form-check form-switch"
                  style={{ fontSize: "0.8rem" }}
                >
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={manual_etapa5}
                    onChange={(e) => setManualEtapa5(e.target.checked)}
                  />
                  <label className="form-check-label">Manual?</label>
                </div>
              </div>
              <input
                type="date"
                className="form-control"
                value={data_termino_etapa5}
                readOnly={!manual_etapa5}
                onChange={(e) => setData_termino_etapa5(e.target.value)}
              />
            </div>
          </div>
          <div className="input-dividido">
            <div className="col">
              <label className="form-label">Situação</label>
              <select
                className="form-control"
                value={situacao_etapa5}
                onChange={(e) => setSituacao_etapa5(e.target.value)}
              >
                <option value="">Escolher</option>
                <option value="Não iniciado">Não iniciado</option>
                <option value="Em andamento">Em andamento</option>
                <option value="Concluído">Concluído</option>
                <option value="Atrasado">Atrasado</option>
              </select>
            </div>
            <div className="col">
              <label className="form-label">Status</label>
              <input
                type="text"
                className="form-control"
                value={status_etapa5}
                onChange={(e) => setStatus_etapa5(e.target.value)}
              />
            </div>
          </div>

          {/* --- Etapa 6 --- */}
          <hr />
          <h3>Etapa 6: Encerramento</h3>
          <div className="input-dividido">
            <div className="col">
              <label className="form-label">Data de Início Etapa 6</label>
              <input
                type="date"
                className="form-control"
                value={data_inicio_etapa6}
                onChange={(e) => setData_inicio_etapa6(e.target.value)}
              />
            </div>
            <div className="col">
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <label className="form-label">Data de Término Etapa 6</label>
                <div
                  className="form-check form-switch"
                  style={{ fontSize: "0.8rem" }}
                >
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={manual_etapa6}
                    onChange={(e) => setManualEtapa6(e.target.checked)}
                  />
                  <label className="form-check-label">Manual?</label>
                </div>
              </div>
              <input
                type="date"
                className="form-control"
                value={data_termino_etapa6}
                readOnly={!manual_etapa6}
                onChange={(e) => setData_termino_etapa6(e.target.value)}
              />
            </div>
          </div>
          <div className="input-dividido">
            <div className="col">
              <label className="form-label">Situação</label>
              <select
                className="form-control"
                value={situacao_etapa6}
                onChange={(e) => setSituacao_etapa6(e.target.value)}
              >
                <option value="">Escolher</option>
                <option value="Não iniciado">Não iniciado</option>
                <option value="Em andamento">Em andamento</option>
                <option value="Concluído">Concluído</option>
                <option value="Atrasado">Atrasado</option>
              </select>
            </div>
            <div className="col">
              <label className="form-label">Status</label>
              <input
                type="text"
                className="form-control"
                value={status_etapa6}
                onChange={(e) => setStatus_etapa6(e.target.value)}
              />
            </div>
          </div>

          {/* --- BOTÕES --- */}
          <div className="input-dividido">
            <div className="col">
              <button type="submit" className="submit-button">
                Atualizar Projeto
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
}

export default EditProjetoCompleto;
